module.exports = __webpack_public_path__ + "static/media/casting_dan.76bada10.jpg";